import ABCyaPhaser from '@abcya/abcya_phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Key from './Key';

export default class Keyboard extends Phaser.GameObjects.Container
{
    constructor(scene, x, y)
    {
        super(scene, x, y);
        scene.add.existing(this);

        this.isActive = false;
        this.keySizeHeight = 75;
        this.keySizeWidth = 55;
        this.keySpacing = 8;

        this.pos = {
            startX:x,
            startY:y,
            endY:this.scene.mid.y*2 - 275
        }

        this.soundInd = 0;

        this.initKeys();
        if(!gameData.DESKTOP) this.tweenInKeyboard();
    }

    initKeys()
    {
        const bgShape = ABCyaPhaser.Graphics.addRect(0, 140, this.scene.mid.x*2, 275, "0xDA6339", this);
    
        //add touch handle to keys for mobile
        if(!gameData.DESKTOP){
            // console.log("creating keyboard");
            this.secondRow = this.createRow(["q","w","e","r","t","y","u","i","o","p",ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.delete_key")]);
            this.midRow = this.createRow(["a","s","d","f","g","h","j","k","l"]);
            this.bottomRow = this.createRow(["z","x","c","v","b","n","m"]);
            this.keys = [this.secondRow,this.midRow,this.bottomRow];
            this.positionKeys();
        }
        else 
        {
            this.isActive = true;
            this.scene.input.keyboard.on('keyup', (event)=>{
                let key;
                if(event.keyCode === 8) key = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.delete_key");
                else  key = event.key;
                this.handleKeyPress(key);
            });
        }
    }

    positionKeys() {
        for(let i = 0; i< this.keys.length; i++){
            // console.info("POS MOBILE KEYS");
            const row = this.keys[i];
            const rowWidth = (row.length * (this.keySizeWidth + this.keySpacing)) - this.keySpacing;
            //messy add to width for shift,delete,etc
            if(i == 3 || i == 2) rowWidth += (this.keySizeWidth);
            if(i == 4) rowWidth += (4 * this.keySizeWidth);
            const rowStart = -(rowWidth/2) - 27;

            //also messy add to start to make uneven?
            const rowY = (i * (this.keySizeHeight + this.keySpacing)) + 20;
            for(let j = 0; j< row.length; j++){

                const key = row[j];
                key.setKeyColors("0xD8D4BC","0xF2EECE");
                key.endX = (j == 0) ? rowStart : row[j - 1].endX + row[j - 1].keyWidth + this.keySpacing;
                key.endY = rowY;
                key.x = key.endX;
                key.y = key.endY;
            }
        }
    };

    handleKeyPress(key)
    {
        if(this.isActive == true)
        {
            const keyVal = key;
            if(!keyVal) return;

            let postion = 1;//its 0 based
            let newStr;

            if(keyVal == ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.delete_key")){
                this.soundInd = 0;

                if(gameData.GHOST_SEL)
                {
                    if(gameData.GHOST_SEL.wordBorder) gameData.GHOST_SEL.wordBorder.visible = false;
    
                    gameData.GHOST_SEL.setWord(gameData.WORD);
                    gameData.GHOST_SEL = null;
                    gameData.WORD = "";
    
                    this.scene.navBar.setScore("--");
                }
            }

            if(gameData.WORD == ""){
                for(let w = 0; w < gameData.WORDS_SELECTED.length; w++) {
                    if(keyVal === gameData.WORDS_SELECTED[w].charAt(0)){
                        gameData.WORD = gameData.WORDS_SELECTED[w];

                        for(let gw = 0; gw < gameData.GHOST_ARR.length; gw++) {
                            if(gameData.GHOST_ARR[gw].innerText == gameData.WORD){
                                //console.log("NEEDED WORD = " + gameData.WORD + " and ghost = " + gw);
                                gameData.GHOST_SEL = null;
                                gameData.GHOST_SEL = gameData.GHOST_ARR[gw];
                                gameData.GHOST_SEL.wordBorder.visible = true;
                                this.soundInd = 0;
                            }
                        }
                        break;
                    }
                }
            }

            if(gameData.WORD != "" && gameData.GHOST_SEL == null){
                gameData.WORD = "";
            } else if(gameData.WORD != "") {
                if(keyVal === gameData.GHOST_SEL.innerText.charAt(0)){
                    newStr = gameData.GHOST_SEL.innerText.substring(0,postion - 1) + gameData.GHOST_SEL.innerText.substring(postion, gameData.GHOST_SEL.innerText.length);
                    gameData.GHOST_SEL.setWord(newStr);

                    this.scene.navBar.setScore("+");
                    this.soundInd++;

                    if(gameData.CORRECT_SOUNDS[this.soundInd]){
                        ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);
                    }
                    else {
                      // play the last correct sound (but pitch it up a bit) since the word has more letters than we have sounds
                      const aboveLastIndex = this.soundInd - (gameData.CORRECT_SOUNDS.length - 1);
                      this.scene.sound.playAudioSprite(ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, gameData.CORRECT_SOUNDS[gameData.CORRECT_SOUNDS.length - 1], { detune: 100 * aboveLastIndex });
                    }
                } else {
                    this.scene.navBar.setScore("-");
                    ABCyaPhaser.Audio.playOneShot("NEW_Incorrect_Key_Ghost_Typing", this.scene);
                }
            }
        }
    };

    tweenInKeyboard()
    {
        ABCyaPhaser.Tweens.addTween(this, 1000, {y:this.pos.endY}, Phaser.Math.Easing.Quadratic.Out, ()=>{ 
            this.isActive = true;

            if(!gameData.DESKTOP){
                this.scene.input.on('gameobjectup', (pointer, gameObject)=>{
                    const keyString = gameObject.parentContainer?.keyStr;
                    if(keyString === undefined) return;
                    this.handleKeyPress(gameObject.parentContainer.keyStr);
                });
            }
        });
    };

    createRow(keys)
    {
        let row = [];
        while(row.length < keys.length){
            const key = new Key(this.scene, this, keys[row.length],this.keySizeWidth,this.keySizeHeight);
            row.push(key);
        }

        return row;
    };
}